

































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import XForm from "../SimpleForm.vue";
import XButton from "../SimpleButton.vue";
import AppApiMixin from "../mixins/AppApi.vue";
import { countersNewValueForm } from "@/assets/scripts/form-fields/main";
import ConfirmActionDialog from "./ModalDialogForIndication.vue";
import { mapGetters } from "vuex";
import XNotice from "@/components/hoc/SimpleNotice.vue";

const { values, attrs, validations, errors } = countersNewValueForm;

@Component({
  components: {
    XForm,
    XButton,
    XNotice,
    ConfirmActionDialog
  },
  mixins: [validationMixin],
  computed: {
    ...errors,
    ...mapGetters("appEnviroment", {
      valuesInputDisabled: "valuesInputDisabled",
    }),
  },
  validations,
})
class CountersNewValueForm extends Mixins(XForm, AppApiMixin) {
  @Prop({ required: true }) readonly rate!: number;
  @Prop({ required: true }) readonly rateFloat!: number;
  @Prop({ required: true }) readonly tarif!: number;
  @Prop({ required: true }) readonly meteringPointId!: number;
  @Prop({ required: true }) readonly counterId!: number;
  @Prop({ required: true }) readonly indication!: number;
  @Prop({ required: false, default: 0 }) readonly asd!: number;
  @Prop({ required: false, default: 1 }) readonly ratio!: number;

  values = { ...values };
  invalidRate = false;
  useSuccessAlert = false;
  successMessage = "Показания успешно переданы на обработку";
  rateFlag = false;

  getMask(str: string) {
    let r = "".padStart(this.rate, str);
    let rf = this.rateFloat > 0 ? "." + "".padStart(this.rateFloat, str) : "";
    let mask = "" + r + rf;
    return mask;
  }

  makeStringMasked(str: string){
    let strSplited = str.split('.')
    str = ''.padStart(this.rate - strSplited[0].length, '0') + strSplited[0];

    if(strSplited[1] === undefined){
      strSplited[1] = ''
    }

    if(this.rateFloat > 0){
      str += `.${strSplited[1]}${"".padStart(this.rateFloat - strSplited[1].length, '0')}`
    }

    return str
  }

  get isAsd() {
    //return this.asd > 0;  //fixme
    return false;
  }

  get consumption() {
    if ((this.values?.indication || "") != "") {
      const ratio = this.ratio > 0 ? this.ratio : 1;
      return (this.values.indication - this.indication) * ratio;
    }
    return 0;
  }

  get rateValidator() {
    const { rate, rateFloat } = this;

    const pattern = {
      template: `^\\d{1,${rate}}*$`,
      replacer: rateFloat > 0 ? `([.,]\\d{1,${rateFloat}})?` : "",
    };

    return new RegExp(pattern.template.replace("*", pattern.replacer));
  }

  public validateRate(readings: string) {
    if (!readings) return true;

    this.rateFlag = false;

    if (!this.rateValidator.test(readings)) {
      this.invalidRate = true;
      return false;
    }

    let currentIndication = readings;
    currentIndication = currentIndication.replace(/,/, '.');

    const readingsAsNumber = parseFloat(currentIndication);

    if (this.indication > readingsAsNumber && readingsAsNumber >= 0) {
      this.rateFlag = true;
    }

    this.invalidRate = false;
    this.submitError = "";

    return true;
  }

  allFieldAttrs = attrs;

  useSubmitButtonLoading = false;
  submitError = "";

  show = false;

  public closeAllDialogs() {
    this.show = false;
    this.useSubmitButtonLoading = false;
  }

  resetData(){
    // this.$refs.simpleForm.reset();
    this.values.indication = '';
    this.$v.$reset();
  }

  showSuccessInfo(){
    this.useSuccessAlert = true;
  }

  submitForm() {
    this.submitError = "";
    this.useSubmitButtonLoading = true;

    this.show = false;
    if (this.rateFlag) {
      this.submitError = "Показание меньше предыдущего";
      this.useSubmitButtonLoading = false;
    } else {
      this.sendData();
    }
  }

  sendData(){

    const { indication } = this.getValues();
    let newIndication = indication.replace(/,/, '.');
    this.sendCountersNewValue(
      this.meteringPointId,
      this.counterId,
      this.tarif,
      +newIndication,
      0,
    )
      .then(() => {
        this.resetData();
        this.showSuccessInfo();
      })
      .catch(() => {
        this.resetData();
        this.closeAllDialogs();

      })
      .finally(() => {
        this.useSubmitButtonLoading = false;
      });

  }
}

export default CountersNewValueForm;
